import { useContext, useEffect, useState } from "react";

import { useSearchParams } from "react-router-dom";
import { Cookies } from "react-cookie";

import { confirmStepLogCode } from "src/data/stepLog/stepLogMessageClass";
import { checkResponse } from "src/components/js/statics1";
import { userContext } from "src/context/userContext";

export default function RefLink() {
  // get ref link from html title bar using params
  // get personId from local storage
  // get authentification from firebase
  // save ref link to db with personId

  // yhdistä pumpputoimittaja ja betonitoimittaja ja henkilö
  // jotta voi valita pumpputoimittajan ja betonitoimittajan
  const { user, isLoggedIn, token } = useContext(userContext) || {};
  const [searchParams, setSearchParams] = useSearchParams();

  const [pumpputoimittajaAsiakasId, setPumpputoimittajaAsiakasId] = useState(0);
  const [betonitoimittajaAsiakasId, setBetonitoimittajaAsiakasId] = useState(0);
  const [personId, setPersonId] = useState(0);

  useEffect(() => {
    // when is authenticated and personId is set and ref link is set
    // then save ref link to db with personId
    const runAsync2 = async () => {
      const cookies = new Cookies();

      await savePersonRefLinkToDB(
        personId,
        pumpputoimittajaAsiakasId,
        betonitoimittajaAsiakasId,
        0,
        token
      );
      cookies.remove("p");
      cookies.remove("b");
      setPumpputoimittajaAsiakasId(0);
      setBetonitoimittajaAsiakasId(0);
    };
    if (
      isLoggedIn &&
      personId > 0 &&
      (pumpputoimittajaAsiakasId > 0 || betonitoimittajaAsiakasId > 0)
    )
      runAsync2();
  }, [isLoggedIn, personId, searchParams]);

  useEffect(() => {
    const runAsync1 = async () => {
      // GET REFLINKS
      // run only once on page load
      // get ref link from html title bar using params
      // save klik to db (and send admin notification)
      // and set state variables
      // and set cookie
      const _pumpputoimittajaAsiakasId = searchParams.get("p");
      const _betonitoimittajaAsiakasId = searchParams.get("b");
      if (_pumpputoimittajaAsiakasId > 0 || _betonitoimittajaAsiakasId > 0) {
        addRefKlikToDB(_pumpputoimittajaAsiakasId, _betonitoimittajaAsiakasId);
        const cookies = new Cookies();
        if (_pumpputoimittajaAsiakasId > 0) {
          setPumpputoimittajaAsiakasId(_pumpputoimittajaAsiakasId);
          cookies.set("p", _pumpputoimittajaAsiakasId);
          // remove the parameter from the url
          searchParams.delete("p");
          setSearchParams(searchParams);
        }
        if (_betonitoimittajaAsiakasId > 0) {
          setBetonitoimittajaAsiakasId(_betonitoimittajaAsiakasId);
          cookies.set("b", _betonitoimittajaAsiakasId);
          // remove the parameter from the url
          searchParams.delete("b");
          setSearchParams(searchParams);
        }
        // set personId from local storage
        // no need to set or get personid if no reflink
        setPersonId(user.personId);
      }

      // GET CONFIRMCODE
      const _confirmCode = searchParams.get("cc");
      if (_confirmCode) {
        // remove the parameter from the url
        confirmStepLogCode(_confirmCode); // don't await this
        searchParams.delete("cc");
        setSearchParams(searchParams);
      }
    };
    runAsync1();
  }, []);

  const addRefKlikToDB = async (pumpputoimittajaAsiakasId, betonitoimittajaAsiakasId) => {
    const url = import.meta.env.VITE_SERVER_URL + "/api/refKlik/addRefKlikToDB";

    const data = {
      pumpputoimittajaAsiakasId: pumpputoimittajaAsiakasId,
      betonitoimittajaAsiakasId: betonitoimittajaAsiakasId,
      sendAdminNotification: true, // TODO: set to false on production
    };
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return (await checkResponse(response, "RefLink.jsx:addRefKlikToDB")).data;
  };

  const savePersonRefLinkToDB = async (
    personId,
    pumpputoimittajaAsiakasId,
    betonitoimittajaAsiakasId,
    lattiatoimittajaAsiakasId,
    token
  ) => {
    const url = import.meta.env.VITE_SERVER_URL + "/api/refKlik/savePersonRefLinkToDB";

    const data = {
      personId: personId,
      pumpputoimittajaAsiakasId: pumpputoimittajaAsiakasId,
      betonitoimittajaAsiakasId: betonitoimittajaAsiakasId,
      lattiatoimittajaAsiakasId: lattiatoimittajaAsiakasId,
    };
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${token}`,
      },
      body: JSON.stringify(data),
    });
    return (await checkResponse(response, "RefLink.jsx:savePersonRefLinkToDB")).data;
  };
}
